module.exports = "/assets/data/8aa8bf33f785630f4a0515606db62656-G32.data.json";